export default "__VITE_ASSET__H0t6mAxM__"